import { Switch } from '@headlessui/react'
import React, { useEffect, useState } from 'react'

type Props = {
  value: boolean,
  onChange: any
  disabled?:boolean
}

const UnControlSwitch = (props: Props) => {
  const { value, onChange, disabled= false } = props
  const [enabled, setEnabled] = useState<boolean>(false)

  const handleToggle = (e:any) => {
    setEnabled((prev: boolean) => !prev);
    onChange(e);
  };

  useEffect(() => {
    if (value) {
      setEnabled(value);
    }
  }, [value]);

  return (
    <>
      <Switch
        checked={enabled}
        onChange={(e:any)=>handleToggle(e)}
        disabled={disabled}
        className={`${enabled ? 'bg-primary' : 'bg-gray-300'}
          relative inline-flex h-5 w-8 shrink-0 cursor-pointer rounded-full border-2 border-transparent transition-colors duration-200 ease-in-out focus:outline-none focus-visible:ring-2  focus-visible:ring-white focus-visible:ring-opacity-75`}
      >
        <span className="sr-only">Use setting</span>
        <span
          aria-hidden="true"
          className={`${enabled ? 'translate-x-3' : 'translate-x-0'}
            pointer-events-none inline-block h-4 w-4 transform rounded-full bg-white shadow-lg ring-0 transition duration-200 ease-in-out`}
        />
      </Switch>
    </>
  )
}

export default UnControlSwitch
